const api = {
  getRankInfo: '/game/sweetHand/getRankInfo',
  getRecommendRid: '/game/sweetHand/getRecommendRid',
  // 喵排行榜
  getAnchorRankList: '/activity/activity_2021JiMiao/getAnchorRankList',
  // 判断是否是主播
  checkAnchorIdentity: '/activity/activity_2021JiMiao/checkAnchorIdentity',
  // 获取任务列表
  getUserTasks: '/activity/activity_2021JiMiao/getUserTasks',
  // 获取房间主播的排名信息 用于判断是否解锁招财猫
  getAnchorRank: '/activity/activity_2021JiMiao/getAnchorRank',
  // 领取充值奖励喵喵
  getRechargeAward: '/activity/activity_2021JiMiao/getRechargeAward',
  // 领取绑手机号奖励 喵喵
  getBindPhoneAward: '/activity/activity_2021JiMiao/getBindPhoneAward',
  // 获得红包雨奖励
  getRainAward: '/activity/activity_2021JiMiao/getRainAward',
  // 女神节列表数据
  getList: 'activity/activity_2021goddess/getList',
  // 中奖信息
  getRecordList: 'activity/activity_2021goddess/getRecordList',
  // 用户完成任务状态
  getUserTask: 'activity/activity_2021goddess/getUserTask',
  // 语音房icon
  getVoiceRoomData: 'activity/activity_2021goddess/getVoiceRoomData',
  // 语音房icon
  getVoiceTaskList: 'activity/activity_2021goddess/getVoiceTaskList'
}
  
export default api